'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deepMerge = require('./deepMerge');

var _deepMerge2 = _interopRequireDefault(_deepMerge);

var _clone = require('../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = {
  primaryCta: {
    color: 'white',
    type: 'PrmryCTA'
  },
  secondaryCta: {
    color: 'outline-white',
    type: 'ScndCTA'
  }
};

var whiteTheme = {
  primaryCta: {
    color: 'blue',
    type: 'PrmryCTA'
  },
  secondaryCta: {
    color: 'outline-blue',
    type: 'ScndCTA'
  }
};

var themeOptions = {
  'theme-background-color-white': whiteTheme,
  'theme-background-color-light': whiteTheme
};

var getTheme = function getTheme(theme) {
  return themeOptions[theme] || defaultTheme;
};
var themeManager = function themeManager(props, theme) {
  var currentTheme = getTheme(theme);
  var newProps = (0, _clone2.default)(props);
  Object.keys(newProps.content).forEach(function (key) {
    if (currentTheme[key]) {
      newProps.content[key] = (0, _deepMerge2.default)(newProps.content[key], currentTheme[key]);
    }
  });
  return newProps;
};

exports.default = themeManager;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/utilities/themeManager.js
// module id = 575
// module chunks = 4